import controller from './home.controller';
import template from './home.html';
import './home.scss';

export default {
	template,
	controller,
};
